import { render, staticRenderFns } from "./DiskMonitoring.vue?vue&type=template&id=0b779f37&scoped=true&"
import script from "./DiskMonitoring.vue?vue&type=script&lang=js&"
export * from "./DiskMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b779f37",
  null
  
)

export default component.exports